export default function Package() {
  const dailyItems = [
    { icon: 'ri-bowl-line', name: 'Beras', color: 'amber' },
    { icon: 'ri-drop-line', name: 'Minyak Masak', color: 'yellow' },
    { icon: 'ri-contrast-drop-2-line', name: 'Gula', color: 'pink' },
    { icon: 'ri-cake-3-line', name: 'Tepung', color: 'orange' },
    { icon: 'ri-cup-line', name: 'Susu / Krimer', color: 'blue' },
    { icon: 'ri-cookie-line', name: 'Biskut / Makanan Asas', color: 'red' }
  ];

  const rayaItems = [
    { icon: 'ri-cake-2-line', name: 'Kuih Kering Pilihan', color: 'emerald' },
    { icon: 'ri-cake-line', name: 'Biskut Raya Pelbagai Jenis', color: 'teal' }
  ];

  return (
    <section id="pakej" className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center gap-2 bg-rose-100 text-rose-700 px-4 sm:px-6 py-2 rounded-full text-xs sm:text-sm font-semibold mb-4 sm:mb-6">
            <i className="ri-shopping-basket-2-line"></i>
            Pakej Bakul Makanan
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-800 mb-4 sm:mb-6 px-4">
            🧺 Pakej Bakul Makanan
          </h2>
          <div className="inline-block bg-gradient-to-r from-amber-500 to-amber-600 text-white px-6 sm:px-8 py-2 sm:py-3 rounded-full text-xl sm:text-2xl font-bold shadow-lg">
            Nilai RM150
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-6 sm:gap-8 mb-8 sm:mb-12">
          {/* Daily Needs */}
          <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-3xl p-6 sm:p-8 shadow-xl border border-amber-100">
            <div className="flex items-center gap-3 mb-4 sm:mb-6">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-amber-500 rounded-xl flex items-center justify-center">
                <i className="ri-shopping-cart-line text-xl sm:text-2xl text-white"></i>
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-gray-800">
                🛒 Bahan Keperluan Harian
              </h3>
            </div>
            
            <div className="grid grid-cols-2 gap-3 sm:gap-4">
              {dailyItems.map((item, index) => (
                <div 
                  key={index}
                  className="bg-white rounded-xl p-3 sm:p-4 shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1 cursor-pointer"
                >
                  <div className={`w-8 h-8 sm:w-10 sm:h-10 bg-${item.color}-100 rounded-lg flex items-center justify-center mb-2 sm:mb-3`}>
                    <i className={`${item.icon} text-lg sm:text-xl text-${item.color}-600`}></i>
                  </div>
                  <div className="text-xs sm:text-sm font-semibold text-gray-800">{item.name}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Raya Items */}
          <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-3xl p-6 sm:p-8 shadow-xl border border-emerald-100">
            <div className="flex items-center gap-3 mb-4 sm:mb-6">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-emerald-500 rounded-xl flex items-center justify-center">
                <i className="ri-cake-3-line text-xl sm:text-2xl text-white"></i>
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-gray-800">
                🍪 Kuih Kering Hari Raya
              </h3>
            </div>
            
            <div className="space-y-3 sm:space-y-4 mb-4 sm:mb-6">
              {rayaItems.map((item, index) => (
                <div 
                  key={index}
                  className="bg-white rounded-xl p-4 sm:p-5 shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1 cursor-pointer"
                >
                  <div className="flex items-center gap-3 sm:gap-4">
                    <div className={`w-10 h-10 sm:w-12 sm:h-12 bg-${item.color}-100 rounded-lg flex items-center justify-center`}>
                      <i className={`${item.icon} text-xl sm:text-2xl text-${item.color}-600`}></i>
                    </div>
                    <div className="text-sm sm:text-base font-semibold text-gray-800">{item.name}</div>
                  </div>
                </div>
              ))}
            </div>

            {/* Image */}
            <div className="w-full h-40 sm:h-48 rounded-2xl overflow-hidden shadow-lg">
              <img 
                src="https://public.readdy.ai/ai/img_res/43c57b77a1613b6346cd8bbb83d91623.jpg"
                alt="Kuih Raya"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="bg-gray-50 rounded-2xl p-4 sm:p-6 border-l-4 border-gray-400">
          <div className="flex items-start gap-3">
            <i className="ri-information-line text-lg sm:text-xl text-gray-600 mt-1"></i>
            <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
              <strong>Nota:</strong> Kandungan tertakluk kepada ketersediaan pembekal tanpa menjejaskan nilai RM150
            </p>
          </div>
        </div>

        {/* Visual Representation */}
        <div className="mt-8 sm:mt-12 text-center">
          <div className="inline-block bg-gradient-to-r from-emerald-100 to-amber-100 rounded-3xl p-6 sm:p-8 shadow-lg w-full max-w-full overflow-x-auto">
            <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 min-w-max sm:min-w-0">
              <div className="text-center">
                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-white rounded-full flex items-center justify-center shadow-md mb-2 sm:mb-3 mx-auto">
                  <i className="ri-shopping-basket-line text-3xl sm:text-4xl text-emerald-600"></i>
                </div>
                <div className="text-xs sm:text-sm font-semibold text-gray-700">1 Bakul</div>
              </div>
              <i className="ri-equal-line text-2xl sm:text-3xl text-gray-400"></i>
              <div className="text-center">
                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-white rounded-full flex items-center justify-center shadow-md mb-2 sm:mb-3 mx-auto">
                  <i className="ri-shopping-cart-line text-3xl sm:text-4xl text-amber-600"></i>
                </div>
                <div className="text-xs sm:text-sm font-semibold text-gray-700">Keperluan Harian</div>
              </div>
              <i className="ri-add-line text-2xl sm:text-3xl text-gray-400"></i>
              <div className="text-center">
                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-white rounded-full flex items-center justify-center shadow-md mb-2 sm:mb-3 mx-auto">
                  <i className="ri-cake-3-line text-3xl sm:text-4xl text-rose-600"></i>
                </div>
                <div className="text-xs sm:text-sm font-semibold text-gray-700">Kuih Raya</div>
              </div>
              <i className="ri-equal-line text-2xl sm:text-3xl text-gray-400"></i>
              <div className="text-center">
                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-amber-500 to-amber-600 rounded-full flex items-center justify-center shadow-md mb-2 sm:mb-3 mx-auto">
                  <span className="text-xl sm:text-2xl font-bold text-white">RM150</span>
                </div>
                <div className="text-xs sm:text-sm font-semibold text-gray-700">Nilai Pakej</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
